export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Contact Info */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-6 font-['Poppins']">
              Get In <strong className="text-teal-500">Touch</strong>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Have questions about our services? Our team is here to help. Reach out to us through any of the channels below, and we'll respond promptly.
            </p>

            <div className="space-y-6">
              {/* Phone */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800 mb-1">Phone</h3>
                  <a href="tel:+15028308648" className="text-slate-600 hover:text-teal-500 transition-colors">
                    (502) 830-8648
                  </a>
                  <p className="text-sm text-slate-500 mt-1">Mon-Fri: 8am - 6pm</p>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800 mb-1">Email</h3>
                  <a href="mailto:Sales@firstinsightcleaning.com" className="text-slate-600 hover:text-teal-500 transition-colors">
                    Sales@firstinsightcleaning.com
                  </a>
                  <p className="text-sm text-slate-500 mt-1">We'll respond within 24 hours</p>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800 mb-1">Office</h3>
                  <p className="text-slate-600">
                    4916 Cawood Dr<br />
                    Louisville, KY 40218
                  </p>
                </div>
              </div>

              {/* Emergency */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
                  <i className="ri-alarm-warning-line text-2xl text-teal-500"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800 mb-1">24/7 Emergency</h3>
                  <a href="tel:+15028308648" className="text-slate-600 hover:text-teal-500 transition-colors">
                    (502) 830-8648
                  </a>
                  <p className="text-sm text-slate-500 mt-1">Available anytime</p>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-8">
              <h3 className="font-semibold text-slate-800 mb-4">Follow Us</h3>
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-slate-100 hover:bg-teal-500 text-slate-600 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-slate-100 hover:bg-teal-500 text-slate-600 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-slate-100 hover:bg-teal-500 text-slate-600 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 flex items-center justify-center bg-slate-100 hover:bg-teal-500 text-slate-600 hover:text-white rounded-lg transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right: Map */}
          <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3134.5!2d-85.7!3d38.2!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s4916+Cawood+Dr+Louisville+KY+40218!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
